import { Controller, useFormContext } from 'react-hook-form';
import { Stack } from '@chakra-ui/react';
import { Callout, Typography } from '@shinetools/sunshine-universal';

import * as Form from 'components/_core/form';
import SunshineCard from 'components/_core/SunshineCard';

import { AccountingExportSchema } from '../../accountingExport.schema';
import locales from './locales';

const DELIMITER = ';';

export const Recipients = () => {
  const { control } = useFormContext<AccountingExportSchema>();

  return (
    <SunshineCard>
      <Stack gap="space-16">
        <Typography.Text bold size="large">
          {locales.title}
        </Typography.Text>

        <Callout>
          <Callout.Content>{locales.callout}</Callout.Content>
        </Callout>

        <Controller
          control={control}
          name="recipients"
          render={({
            field: { onChange, value },
            fieldState: { error },
            formState: { errors },
          }) => {
            // Gets error message from array element validation
            const elementError = errors.recipients?.filter?.(
              (recipientsError) => recipientsError?.message,
            )?.[0];

            return (
              <Form.Field
                error={error?.message || elementError?.message}
                hint={locales.inputHint}
                label={locales.inputLabel}
              >
                <Form.Input
                  onChange={(newValue) => {
                    if (!newValue.target.value) {
                      onChange([]);
                    } else {
                      onChange(newValue.target.value.split(DELIMITER));
                    }
                  }}
                  value={value?.join(DELIMITER)}
                />
              </Form.Field>
            );
          }}
        />
      </Stack>
    </SunshineCard>
  );
};
